import { Row } from 'antd';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';

export const StyledRow = styled(Row)`
  flex-wrap: nowrap;
`;

export const StyledSelect = css`
  .ozone-select__value-container {
    max-height: 112px;
    overflow: scroll;
  }
`;

export const StyledButton = styled(Button)`
  margin-left: var(--spacing-03);
`;
